import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "apt-glossary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "부동산 용어사전"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "부동산 거래와 투자에 필요한 핵심 용어를 알아보세요")
], -1)
const _hoisted_3 = { class: "glossary-controls" }
const _hoisted_4 = { class: "search-box" }
const _hoisted_5 = { class: "category-tabs" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "glossary-count" }
const _hoisted_8 = { class: "glossary-list" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-term" }
const _hoisted_11 = { class: "card-category" }
const _hoisted_12 = { class: "card-desc" }
const _hoisted_13 = {
  key: 0,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
          type: "text",
          placeholder: "용어 검색...",
          class: "search-input"
        }, null, 512), [
          [_vModelText, _ctx.searchQuery]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
          return (_openBlock(), _createElementBlock("button", {
            key: cat,
            class: _normalizeClass(['tab-btn', { active: _ctx.selectedCategory === cat }]),
            onClick: ($event: any) => (_ctx.selectedCategory = cat)
          }, _toDisplayString(cat), 11, _hoisted_6))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createTextVNode(" 총 "),
      _createElementVNode("strong", null, _toDisplayString(_ctx.filteredTerms.length), 1),
      _createTextVNode("개 용어 ")
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTerms, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.term,
          class: "glossary-card"
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(item.term), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(item.category), 1)
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(item.description), 1)
        ]))
      }), 128))
    ]),
    (_ctx.filteredTerms.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 검색 결과가 없습니다. "))
      : _createCommentVNode("", true)
  ]))
}